import { Actions, ActionTypes } from './actions';
import { generalAdapter, initialState, GeneralState } from './state';

export function GeneralReducer(state = initialState, action: Actions): GeneralState {
  switch (action.type) {
    case ActionTypes.ADD_STATE: {
      return generalAdapter.addOne(action.payload.data, state);
    }
    case ActionTypes.CHANGE_HEADER: {
       return generalAdapter.updateOne({
        id: action.id,
        changes: action.changes,
      }, state);
    }
    case ActionTypes.CHANGE_LOADING_STATUS: {
      return generalAdapter.updateOne({
        id: action.id,
        changes: action.changes,
      }, state);
    }
    case ActionTypes.CHANGE_SORT_BY_OPTION: {
      return generalAdapter.updateOne({
        id: action.id,
        changes: action.changes,
      }, state);
    }
    case ActionTypes.CHANGE_LAST_REQUEST_ASKED: {
      return generalAdapter.updateOne({
        id: action.id,
        changes: action.changes,
      }, state);
    }
    case ActionTypes.CHANGE_HOTEL_INFO: {
      return generalAdapter.updateOne({
        id: action.id,
        changes: action.changes,
      }, state);
    }
    case ActionTypes.CHANGE_BOOKING_ACTION: {
      return generalAdapter.updateOne({
        id: action.id,
        changes: action.changes,
      }, state);
    }
    case ActionTypes.SET_USER_INFO: {
      return generalAdapter.updateOne({
        id: action.id,
        changes: action.changes,
      }, state);
    }
    case ActionTypes.SET_UNREAD_MESSAGES: {
      return generalAdapter.updateOne({
        id: action.id,
        changes: action.changes,
      }, state);
    }
    case ActionTypes.SET_ACTIVE_OFFERS: {
      return generalAdapter.updateOne({
        id: action.activeOfferes,
        changes: action.changes,
      }, state);
    }
    case ActionTypes.TOGGLE_LOGIN_MODAL: {
      return generalAdapter.updateOne({
        id: action.id,
        changes: action.changes,
      }, state);
    }
    case ActionTypes.SET_BOOK_NOW_BUTTON_CLICKED: {
      return generalAdapter.updateOne({
        id: action.id,
        changes: action.changes,
      }, state);
    }
    case ActionTypes.SEND_REQUEST_ENABLED: {
      return generalAdapter.updateOne({
        id: action.id,
        changes: action.changes,
      }, state);
    }
    case ActionTypes.CHANGE_FOOTER: {
      return generalAdapter.updateOne(action.payload, state);
    }
    default: {
      return state;
    }
  }
}
